import { initialState } from './appointment-reducer';
/*
Append new string value to the array provided that its not duplicate or empty string.
*/
const merge = (arr, newStringValue) =>
  (arr && newStringValue
    && newStringValue.length > 0
    && arr.map((a) => a.toLowerCase())
      .indexOf(newStringValue.toLowerCase()) === -1 ?
    arr.concat(newStringValue) :
    arr);

const buildFilterOptionsState = (statuses, appointmentTypes, providers) => ({
  statuses,
  appointmentTypes,
  providers,
});

const insensitiveCaseSort = (a, b) => (a ? a.localeCompare(b) : -1);

export const extractApptFilterOptions = (appointments) => {
  const apptsModel = appointments || [];
  if (apptsModel.length < 1) {
    return null;
  }

  return apptsModel.reduce((prevFilterOptions, currAppt) =>
    buildFilterOptionsState(
      merge(prevFilterOptions.statuses, currAppt.status ? currAppt.status.trim() : '')
        .sort(insensitiveCaseSort),
      merge(prevFilterOptions.appointmentTypes, currAppt.type ? currAppt.type.trim() : '')
        .sort(insensitiveCaseSort),
      merge(prevFilterOptions.providers, currAppt.provider ? currAppt.provider.trim() : '')
        .sort(insensitiveCaseSort)
    ),
  initialState.filterOptions);
};
